import React from 'react';
import styled from 'styled-components';

// --- STYLED COMPONENTS ---

const BackgroundVideo = styled.video`
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: translate(-50%, -50%);
    z-index: -2;
`;

const VideoOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(rgba(42, 125, 225, 0.7), rgba(42, 125, 225, 0.7));
    z-index: -1;
`;

const HeroContent = styled.div`
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const HeroSection = styled.section`
    position: relative;
    overflow: hidden;
    color: #fff;
    padding: 6rem 2rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80vh; /* Example height */
`;

const HeroTitle = styled.h1`
    font-size: 3rem;
    margin-bottom: 1rem;
`;

const HeroSubtitle = styled.p`
    font-size: 1.2rem;
    max-width: 600px;
    margin: 0 auto 2rem auto;
`;

const CTAButton = styled.a`
  background-color: #f5a623;
  color: #fff;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 600;
  &:hover {
    background-color: #d88e1a;
  }
`;

const Section = styled.section`
  padding: 4rem 2rem;
  text-align: center;
`;

const SectionTitle = styled.h2`
  font-size: 2.2rem;
  margin-bottom: 2rem;
`;

// --- COMPONENT ---

const Home = () => {
    return (
        <>
            <HeroSection>
                <VideoOverlay />
                <BackgroundVideo autoPlay loop muted playsInline>
                    {/* Ensure this path is correct based on your public folder */}
                    <source src="/home-background.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </BackgroundVideo>
                <HeroContent>
                    <HeroTitle>Friendship First. Growth Always.</HeroTitle>
                    <HeroSubtitle>A warm, relationship-based approach to ABA therapy, helping your child build skills for today and confidence for tomorrow.</HeroSubtitle>
                    <CTAButton href="/contact">Get Started</CTAButton>
                </HeroContent>
            </HeroSection>

            <Section>
                <SectionTitle>More Than Therapy—A Partnership for Growth</SectionTitle>
                <p style={{ maxWidth: '800px', margin: '0 auto' }}>
                    BeFriend is a child-focused ABA service dedicated to helping kids build the skills they need to thrive in daily life. What makes us different is our warm, relationship-based approach—we combine evidence-based ABA therapy with a focus on connection, friendship, and confidence. We work closely with families, schools, and communities to ensure progress feels natural, supportive, and lasting.
                </p>
            </Section>
        </>
    );
};

export default Home;